/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const simCardConstants = {
    SIM_CARD_LIST: 'sim_card_list',
    SIM_CARD_EDIT: 'sim_card_edit',
    SIM_CARD_DELETE: 'sim_card_delete',
    SIM_CARD_MANAGE: 'sim_card_manage',
    SIM_CARD_ADD: 'sim_card_add',

    SIM_CARD_TARIFF_ICCID: 'sim_card_get_tariff_iccid_range',
    SIM_CARD_EDIT_ITEM: 'sim_card_edit_item',

    SIM_CARD_SERVICES_GET_ALL: 'sim_card_services_get_all',
    SIM_CARD_CHANGE_MSISDN_REQUEST: 'sim_card_change_msisdn_request',

    D_SIM_CARD_LOAD_ITEM: 'd_sim_card_load_item',
    D_SIM_CARD_SYNCHRONIZE_SERVICES: 'd_sim_card_synchronize_services',
    D_SIM_CARD_GET_SYNCHRONIZE: 'd_sim_card_get_synchronize',
};

export class simCardActions extends defaultActions {}
